import { render, staticRenderFns } from "./main-nav.vue?vue&type=template&id=315cf63e&scoped=true"
import script from "./main-nav.vue?vue&type=script&lang=ts"
export * from "./main-nav.vue?vue&type=script&lang=ts"
import style0 from "./main-nav.vue?vue&type=style&index=0&id=315cf63e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315cf63e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315cf63e')) {
      api.createRecord('315cf63e', component.options)
    } else {
      api.reload('315cf63e', component.options)
    }
    module.hot.accept("./main-nav.vue?vue&type=template&id=315cf63e&scoped=true", function () {
      api.rerender('315cf63e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/_components/main-nav/main-nav.vue"
export default component.exports